module.exports = __webpack_public_path__ + "files/022a3b87fdc6e6a096f67552f7cf64d8.png";